<template>
  <div class="integral-borrowing">
    <div class="list-search">
      <a-form>
        <a-row>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="订单编号"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-input v-model="tradeName" allow-clear placeholder="请输入订单编号" />
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="支付方式"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-select
                v-model="payType"
                allow-clear
                placeholder="全部"
                show-search
                option-filter-prop="children"
              >
                <a-select-option :value="1">
                  现金
                </a-select-option>
                <a-select-option :value="6">
                  银行卡
                </a-select-option>
                <a-select-option :value="11">
                  优惠券
                </a-select-option>
                <a-select-option :value="14">
                  微信
                </a-select-option>
                <a-select-option :value="15">
                  钱包
                </a-select-option>
                <a-select-option :value="16">
                  支付宝
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="6">
            <a-form-item
              label="近期交易"
              :label-col="{ span: 5 }"
              :wrapper-col="{ span: 19 }"
            >
              <a-range-picker v-model="date" :format="dateFormat" :value-format="valueFormat" />
            </a-form-item>
          </a-col>
          <a-col class="search-item" :span="6" align="right">
            <a-form-item>
              <a-button type="primary" class="mr8" @click="toSearch">
                查询
              </a-button>
              <a-button @click="resetTable">
                重置
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table">
      <a-table
        :columns="columns"
        :data-source="tableData"
        :pagination="pagination"
        :row-key="record => record.id"
        :loading="loading"
        :scroll="{y:'50vh'}"
        class="table-content"
        @change="handleTableChange"
      >
        <template slot="operate" slot-scope="text">
          <a-button type="link" size="small" @click="view(text)">
            订单详情
          </a-button>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import { getAhsOrderList } from '@/api/transacManage'
import { unixToDate } from '@/utils/formatDate'

const columns = [
  {
    title: '订单编号',
    key: 'orderNo',
    dataIndex: 'orderNo',
    align: 'center'
  },
  {
    title: '提交时间',
    key: 'createdAt',
    dataIndex: 'createdAt',
    customRender: (text, record, index) => {
      return unixToDate(text)
    },
    align: 'center'
  },
  {
    title: '支付时间',
    key: 'completedAt',
    dataIndex: 'completedAt',
    customRender: (text, record, index) => {
      return unixToDate(text)
    },
    align: 'center'
  },
  {
    title: '数量',
    key: 'title',
    dataIndex: 'title',
    customRender: () => 1,
    align: 'center'
  },
  {
    title: '成交价(元)',
    key: 'finalAmount',
    dataIndex: 'finalAmount',
    align: 'center'
  },
  {
    title: '支付方式',
    key: 'paymentType',
    dataIndex: 'paymentType',
    customRender: (text, record, index) => {
      switch (text) {
        case 1:
          return '现金'
        case 6:
          return '银行卡'
        case 11:
          return '优惠券'
        case 14:
          return '微信'
        case 15:
          return '钱包'
        case 16:
          return '支付宝'
        default:
          break
      }
    },
    align: 'center'
  },
  {
    title: '订单状态',
    key: 'status',
    dataIndex: 'status',

    align: 'center'
  },
  {
    title: '操作',
    key: 'operate',
    width: 150,
    fixed: 'right',
    scopedSlots: { customRender: 'operate' },
    align: 'center'
  }
]
export default {
  data () {
    return {
      columns,
      // 商品名称
      tradeName: '',
      /** 商品分组 */
      payType: undefined,
      // 发布时间
      date: '',
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      valueFormat: 'YYYY-MM-DD HH:mm:ss',
      /**
       * 列表
       *
       */
      // 列表数据
      tableData: [],
      // 分页数据
      pagination: {
        current: 1,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: total => '共' + total + '条记录',
        pageSizeOptions: ['10', '20', '30', '40'],
        defaultPageSize: 10,
        pageSize: 10,
        total: 0
      },
      // 列表loading
      loading: false
    }
  },
  created () {
    this.getAhsOrderList()
  },
  mounted () {
    this.getArea('', 2, null, true)
  },
  methods: {
    // 列表
    // 获取列表
    async getAhsOrderList () {
      const params = {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize,
        startTime: this.date[0],
        endTime: this.date[1],
        paymentType: this.payType,
        orderNo: this.tradeName
      }
      this.loading = true
      try {
        const res = await getAhsOrderList(params)
        console.log(res)
        if (res.code === 0) {
          this.tableData = res.result.list
          this.pagination.total = res.result.totalCount
        }
      } finally {
        this.loading = false
      }
    },
    handleTableChange (pagination, filters, sorter) {
      this.pagination.pageSize = pagination.pageSize
      this.pagination.current = pagination.current
      this.getAhsOrderList()
    },
    // 查询
    toSearch () {
      this.getAhsOrderList()
    },
    // 重置
    resetTable () {
      this.page = 1
      this.pageSize = 10
      this.tradeName = ''
      this.payType = undefined
      this.date = []
    },
    // 查看
    view (item) {
      this.$router.push({
        path: '/transacView',
        query: { id: item.id }
      })
    }
  }
}

</script>
<style lang='less' scoped>
.integral-borrowing{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .list-search{
    width: 100%;
    margin-bottom: 16px;
    background-color: #fff;
    padding: 16px 20px 7px 20px;
    .city{
      margin-right: 10px;
    }
    .mr8{
      margin-right: 10px;
    }
  }
  .table{
    flex: 1;
    background: #fff;
    padding: 16px 20px 7px 20px;
    box-sizing: border-box;
  }
  /deep/ .ant-input,
  /deep/ .ant-col-19,
  /deep/ .ant-form-item-control,
  /deep/ .ant-cascader-picker,
  /deep/ .ant-cascader-picker-label{
    width: 220px;
  }
  .userInfo{
    display: flex;
    >div{
      flex: 1;
      text-align: left;
    }
    >span{
      flex: 1;
      text-align: left;
    }
  }
}
</style>

<style lang="stylus" scoped>
.dlContent
  .dlIcon
    font-size 30px
  .dlTitle
    vertical-align text-bottom
    padding-left: 10px
    font-size: 16px
    color: #333
    font-weight: 500
  .dlMain
    position absolute
    top 64px
    left 64px
    color #666
    font-size 14px
.dlMain
    width: 1
</style>

